export const API_URL = "https://api.coingecko.com/api/v3/coins";
